import { render, staticRenderFns } from "./AgregarCarpeta.vue?vue&type=template&id=bcb67502"
import script from "./AgregarCarpeta.vue?vue&type=script&lang=js"
export * from "./AgregarCarpeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports